import React from "react";
import axios, { AxiosRequestConfig } from "axios";
import { useTranslation } from "react-i18next";
import { setSnackbar } from "../../../util/state/globalAction";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../util/state/globalVariables";
import { HTTPGenericResponse } from "../constants/FinanceModels";

export const useApi = () => {

    const { t } = useTranslation('finance');
    const { dispatchGlobalData } = React.useContext(GlobalContext);


    const setEventListenerLoading = (value: boolean) => {
        window.dispatchEvent(new CustomEvent('LOADING', { detail: value }))
    }


    function GET(url: string, config?: AxiosRequestConfig<any>, loading = false) {
        if (loading) {
            setEventListenerLoading(true);
        }

        return axios.get<HTTPGenericResponse>(url, config).then((response) =>
             onSuccess(response, loading))
            .catch((error) =>
                onError(error, loading));
    }

    function POST(url: string, payload?: any, config?: AxiosRequestConfig<any>, loading = false) {
        if (loading) {
            setEventListenerLoading(true);
        }
        return axios.post<HTTPGenericResponse>(url, payload, config).then((response) =>
            onSuccess(response, loading)).catch((error) =>
            onError(error, loading));
    }

    function PUT(url: string, payload?: any, config?: AxiosRequestConfig<any>, loading = false) {
        if (loading) {
            setEventListenerLoading(true);
        }
        return axios.put<HTTPGenericResponse>(url, payload, config).then((response) =>
            onSuccess(response, loading)).catch((error) =>
            onError(error, loading));
    }

    function DELETE(url: string, config?: AxiosRequestConfig<any>, loading = false) {
        if (loading) {
            setEventListenerLoading(true);
        }
        return axios.delete<HTTPGenericResponse>(url, config).then((response) =>
            onSuccess(response, loading)).catch((error) =>
            onError(error, loading));
    }

    const onSuccess = function (response: any, loading?: any) {
        console.debug('Request Successful!', response);
        if(loading)
            setEventListenerLoading(false);
        return response.data;
    }

    const onError = function (error: any, loading?: any) {
        if(loading)
            setEventListenerLoading(false);
        if (axios.isCancel(error)) {
            return Promise.reject();
        }

        dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message: t('api.snackbars.errors.generic'),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: false,
                }
            }
        });

        console.error('Request Failed:', error.config);

        if (error.response) {
            // Request was made but server responded with something other than 2xx
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data);
            console.error('Headers:', error.response.headers);

        } else {
            // Something else happened while setting up the request triggered the error
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    }


    return { GET, POST, PUT, DELETE };
}